<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="计划名称">
              <a-input allowClear placeholder="请输入保养计划名称" v-model="queryParam.planName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="计划类型">
              <j-dict-select-tag
                :showPlease="false"
                dictCode="plan_class"
                placeholder="请选择计划类型"
                v-model="queryParam.planType"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div :style="{justifyContent: pageTypeEumList? 'space-between' : 'flex-end'}" class="flex justify-between">
      <div class="table-operator" v-if="pageTypeEumList">
        <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
        <a-button @click="handleExportXls('保养计划')" icon="download" type="primary">导出</a-button>
        <a-upload
          :action="importExcelUrl"
          :headers="tokenHeader"
          :multiple="false"
          :showUploadList="false"
          @change="handleImportExcel"
          name="file"
        >
          <a-button icon="import" type="primary">导入</a-button>
        </a-upload>
        <!-- 高级查询区域 -->
        <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item @click="batchDel" key="1">
              <a-icon type="delete" />删除
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
    </div>

    <!-- table区域-begin -->
    <div v-if="pageTypeEumList">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <!--                <a-tag v-if="isEnd==0" color="#52c41a">否</a-tag>
        <a-tag v-else color="#ff4d4f">是</a-tag>-->
        <template slot="status" slot-scope="text">
          <a-tag :color="text==1?'#52c41a':'#108ee9'">{{text==0?'已停用':'已启用'}}</a-tag>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />

          <a @click="handleOpend(record,record.planStatus===0?1:0)">{{record.planStatus===0?`启用`:'停用'}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <maintaince-plan-calendar v-else />
    <dev-maintaince-plan-modal @ok="modalFormOk" ref="modalForm"></dev-maintaince-plan-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevMaintaincePlanModal from './modules/DevMaintaincePlanModal'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import MaintaincePlanCalendar from './MaintaincePlanCalendar.vue'
  import { getAction, httpAction, postAction } from '../../api/manage'
  // import DragTable from '@/components/DragTable'

  export default {
    name: 'DevMaintaincePlanList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevMaintaincePlanModal, MaintaincePlanCalendar
    },
    data () {
      return {
        description: '保养计划管理页面',
        // 表头
        columns: [

          {
            title: '计划名称',
            align: "center",
            dataIndex: 'planName'
          },
          {
            title: '计划日期',
            align: "center",
            dataIndex: 'planDate',
            customRender: function (text, record) {
              if (text) {
                return record.planCycle == 1 ? filterDictTextByCache('planned_date', text) : `${text}号`
              } else {
                return ''
              }
            }
          },
          {
            title: '保养时间',
            align: "center",
            dataIndex: 'maintenanceStartTime',
            customRender: function (text, record) {
              return record.maintenanceStartTime + '-' + record.maintenanceEndTime
            }
          },

          {
            title: '计划周期',
            align: "center",
            dataIndex: 'planCycle',
            customRender: function (text, record) {
              return filterDictTextByCache('planning_cycle', text)
            }
          },



          {
            title: '提醒时间',
            align: "center",
            dataIndex: 'reminderTime',
            sorter: true,
            customRender: function (text, record) {
              return text + '分钟'
            }
          },

          {
            title: '计划类型',
            align: "center",
            dataIndex: 'planType',
            customRender: function (text, record) {
              return filterDictTextByCache('plan_class', text)
            },
            sorter: true,
          },
          {
            title: '计划状态',
            dataIndex: 'planStatus',
            align: "center",
            width: 147,
            scopedSlots: { customRender: 'status' },
            sorter: true,
          },
          {
            title: '维保操作说明',
            align: "center",
            dataIndex: 'operation'
          },
          {
            title: '养护周期(天)',
            align: "center",
            dataIndex: 'maintainceIntervals',
            sorter: true,
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            // fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        queryParam: {},

        url: {
          list: "/maintenance/devMaintaincePlan/list",
          delete: "/maintenance/devMaintaincePlan/delete",
          deleteBatch: "/maintenance/devMaintaincePlan/deleteBatch",
          exportXlsUrl: "/maintenance/devMaintaincePlan/exportXls",
          importExcelUrl: "maintenance/devMaintaincePlan/importExcel",
          opend: '/maintenance/devMaintaincePlan/isOpened'
        },
        dictOptions: {},
        superFieldList: [],
        pageType: 'list',
        isorter: {
          column: 'planStatus',
          order: 'asc'
        },
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      pageTypeEumList () {
        return this.pageType === 'list'
      }
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'devId', text: '设备标识', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devMaintenanceStlId', text: '标准库ID', dictCode: '' })
        fieldList.push({ type: 'string', value: 'operation', text: '维保操作说明', dictCode: '' })
        fieldList.push({ type: 'int', value: 'maintainceIntervals', text: '养护周期(天)', dictCode: '' })
        fieldList.push({ type: 'date', value: 'startTime', text: '计划开始时间' })
        fieldList.push({ type: 'date', value: 'endTime', text: '计划结束时间' })
        fieldList.push({ type: 'date', value: 'nextTime', text: '下次任务时间' })
        fieldList.push({ type: 'int', value: 'planStatus', text: '计划状态(0开启,进行中,关闭)', dictCode: '' })
        // fieldList.push({ type: 'plan_class', value: 'planType', text: '计划类型', dictTable: '`iwt-wf`.dev_list', dictText: '', dictCode: 'id' })
        this.superFieldList = fieldList
      },
      triggerBtn (val) {
        this.pageType = val
      },
      handleOpend (v, status) {

        postAction(this.url.opend, { id: v.id, planStatus: status }).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
          }
        })
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>